export default {
  TEMPLATE: 'template',
  BLANK_TEMPLATE: 'blank-template',
  AI_SITE: 'ai-site',
};
